import { useCallback, useContext, useEffect } from 'react';
import { getRandomItem } from '@/modules/gameUtils/random';
import { AudioAutoPlayerContext } from '@/shared/Players/AudioAutoPlayer/AudioAutoPlayerContext';
import useWait from '@/shared/GameComponents/useWait.hook';

export default function useAnswerFeedback({ game, assets }) {
  const audioPlayer = useContext(AudioAutoPlayerContext);
  const { wait, cancelWait } = useWait();

  useEffect(() => {
    const currentConcept = game.state.currentConcept;
    const isRightAnswer = game.state.currentAnswerId == currentConcept.id;
    const feedbackSounds = isRightAnswer
      ? [assets.sounds[currentConcept.id].audio, getCorrectFeedbackAudio()]
      : [getIncorrectFeedbackAudio(), assets.sounds[currentConcept.id].audio];

    const playFeedbackAudio = async () => {
      await audioPlayer.actions.play(feedbackSounds);
      await wait(1000);
      game.actions.setState({
        feedbackFinished: true,
      });
    };
    playFeedbackAudio();
    return () => {
      cancelWait();
    };
  }, [
    game.state.currentConcept,
    game.state.currentAnswerId,
    game.state.givingFeedback,
    assets,
  ]);

  const getIncorrectFeedbackAudio = useCallback(() => {
    const incorrectAudios = ['oo', 'oooo'];
    return assets.sounds[getRandomItem(incorrectAudios)].audio;
  }, [assets]);

  const getCorrectFeedbackAudio = useCallback(() => {
    const correctAudios = ['bien', 'muybien', 'bravo', 'perfecto'];
    return assets.sounds[getRandomItem(correctAudios)].audio;
  }, [assets]);
}
